import { seedEdition } from "./data/stories";
import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const boot = window.__STANDARD_BOOT__;
if (boot?.stories) seedEdition(boot);
const container = document.getElementById("root");
const tree = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);
if (boot?.stories) ReactDOM.hydrateRoot(container, tree);
else ReactDOM.createRoot(container).render(tree);
